var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:(_vm.rootStyle)},[_c('v-content',{class:_vm.cssClass},[_c('router-view',{key:_vm.$route.fullPath}),_c('app-footer',{attrs:{"app":""}})],1),_c('LegalAgeMessage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }